import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { ExActions, ExMutations } from "@/exstore/ExStoreEnums";
import ExApiService from "@/excore/ExApiService";
import { ErrorPopup } from "@/excore/Popup";

export interface Sepet {
  donations: DonationModel[];
}
interface DonationModel {
  id: number;
  user_id: number;
  donor_id: number;
  method: string;
  details: DonationDetailModel[];
  is_selected: boolean;
}
interface DonationDetailModel {
  id: number;
  amount: number | undefined;
  unit: number | undefined;
  currency: string;
  campaign_id: number;
  recurring_donation_id: number | undefined;
  intent_id: number;
}
@Module
export default class ExSepetModule extends VuexModule {
  sepet = { donations: [] } as Sepet;

  get currentSepet(): Sepet {
    return this.sepet;
  }
  // @Mutation
  // [ExMutations.SEPETE_DONATION_VE_DETAIL_EKLE](payload) {
  //   console.log("SEPETE_DONATION_VE_DETAIL_EKLE", payload);
  //   this.sepet.donations.push(payload);
  // }
  @Mutation
  [ExMutations.SET_SEPET](sepet) {
    this.sepet.donations = sepet;
  }
  @Mutation
  [ExMutations.SEPET_SIL]() {
    this.sepet.donations = this.sepet.donations.filter((dn) => !dn.is_selected);
  }
  @Mutation
  [ExMutations.DONATION_DETAIL_DUZENLE]({ donationIndex, detailIndex, detail }) {
    this.sepet.donations[donationIndex].details[detailIndex] = detail;
  }
  @Action
  async [ExActions.SEPETE_DONATION_VE_DETAIL_EKLE]({ donor_id, detail, method, receipt }) {
    const donation = {
      user_id: this.context.getters.currentUser.id,
      donor_id: donor_id,
      method: method,
      details: [detail],
      donation_date: receipt?.donation_date,
      receipt_type: receipt?.receipt_type,
      receipt_number: receipt?.receipt_number,
    };
    try {
      const [error, resp] = await ExApiService.post("basket", donation);
      await this.context.dispatch(ExActions.UPDATE_SEPET);
      return [error, resp];
    } catch (error) {
      return [error];
    }
  }
  @Action
  async [ExActions.SEPETTEN_DONATION_VE_DETAIL_SIL](detailId) {
    try {
      const [error, resp] = await ExApiService.delete<any[]>("donation-detail/" + detailId);
      if (error) {
        return ErrorPopup(error);
      }
      await this.context.dispatch(ExActions.UPDATE_SEPET);
      return [error, resp];
    } catch (error) {
      return [error];
    }
  }
  @Action
  async [ExActions.SEPETTEKI_DONATION_DETAILI_DUZENLE]({ donationDetailId, donationDetail, donation }) {
    const data = {
      donation: {
        ...donation,
      },
      ...donationDetail,
    };
    try {
      const [error, resp] = await ExApiService.put<any[]>(
        "donation-detail/" + donationDetailId,
        donation ? data : donationDetail
      );
      return [error, resp];
    } catch (error) {
      return [error];
    }
  }
  @Action
  async [ExActions.SEPETI_ONAYLA]() {
    try {
      const [error, resp] = await ExApiService.post<any[]>("donation", this.sepet.donations);
      await this.context.dispatch(ExActions.UPDATE_SEPET);
      return [error, resp];
    } catch (error) {
      return [error];
    }
  }
  @Action
  async [ExActions.SEPETI_TEMIZLE]() {
    let ids: any = [];
    this.sepet.donations.forEach((i) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return ids.push(i.id);
    });
    ids = ids.join(",");
    try {
      const [error, resp] = await ExApiService.delete("donation?columns=donation.id&column_types=70&query=" + ids);
      if (!error) {
        this.context.commit(ExMutations.SEPET_SIL);
      }
      return [error, resp];
    } catch (error) {
      return [error];
    }
  }
  @Action
  async [ExActions.UPDATE_SEPET]() {
    if (this.context.getters.isUserAuthenticated !== true) {
      return;
    }
    const [error, data] = await ExApiService.get(
      "donation?page=1&per_page=50&columns=sepet.status&column_types=20&query=1"
    );
    if (error) {
      ErrorPopup(error);
      return;
    }
    this.context.commit(ExMutations.SET_SEPET, data.data);
  }
}
